import { BaseServices } from 'src/app/kuba/kuba.services';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
// Add ChangeDetectorRef import
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef
} from '@angular/core';

import { MoveBusinessServices } from './../services/move-business.service';
import { BusinessView } from './../../businesses/models/businessView';
import { ToasterComponent } from './../../../_directives/toaster.component';
import { TranslateService } from '@ngx-translate/core';
import { BusinessPortalService } from 'src/app/kuba/portals/services/business-portal.services';
import * as _ from 'lodash';
import { PortalUser } from '../models/portalUser';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'move-business',
  templateUrl: 'move-business.component.html'
})
export class MoveBusinessComponent implements OnInit, OnDestroy {
  @ViewChild(ToasterComponent, { static: false })
  toasterComponent: ToasterComponent;
  moveBusinessForm: FormGroup;
  Users: any[] = [];
  SelectedUser: any[] = [];
  businesslist: any = [];
  selectedBusiness: any = [];
  selectedUserId: number | null = null;
  isFromUserSelected = false;
  userId: number | null = null;
  selectedUserList: any[] = [];
  tblUser: PortalUser[] = [];
  loading = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private moveBusinessServies: MoveBusinessServices,
    private _fb: FormBuilder,
    private translate: TranslateService,
    private businessPortalService: BusinessPortalService,
    private cdr: ChangeDetectorRef // Inject ChangeDetectorRef
  ) {
    this.moveBusinessForm = this._fb.group({
      fromUser: [null],
      toUser: [null]
    });
  }

  ngOnInit() {
    this.loadInitialUsers();
    this.initializeDropdowns();
  }

  loadInitialUsers() {
    const list = this.route.snapshot.data['list'];
    if (list) {
      const initialUsers: any[] = [
        { label: this.translate.instant('SELECT_DROPDOWN.SELECT'), value: null }
      ];
      list.forEach((listData: any) => {
        initialUsers.push({
          label: listData.Name,
          value: listData.Id,
          portalManId: listData.PortalManagerId
        });
      });
      this.Users = initialUsers;
    } else {
      this.Users = [
        { label: this.translate.instant('SELECT_DROPDOWN.SELECT'), value: null }
      ];
    }
    this.cdr.detectChanges(); // Ensure initial list renders if loaded synchronously
  }

  initializeDropdowns() {
    this.SelectedUser = [
      { label: this.translate.instant('SELECT_DROPDOWN.SELECT'), value: null }
    ];
    if (!this.Users || this.Users.length === 0) {
      this.Users = [
        { label: this.translate.instant('SELECT_DROPDOWN.SELECT'), value: null }
      ];
    }
    this.cdr.detectChanges(); // Ensure initial placeholders render
  }

  onFromUserChange(e: any) {
    this.businesslist = [];
    this.selectedBusiness = [];
    this.SelectedUser = [];
    this.tblUser = [];
    this.selectedUserList = [];
    this.moveBusinessForm.get('toUser')?.reset();
    this.initializeDropdowns(); // Reset 'To' dropdown

    const selectedOption = e.value
      ? this.Users.find(u => u.value === e.value)
      : null;

    if (!selectedOption || selectedOption.value === null) {
      this.isFromUserSelected = false;
      this.userId = null;
      return;
    }

    this.isFromUserSelected = true;
    this.userId = selectedOption.portalManId
      ? selectedOption.portalManId
      : selectedOption.value;
    const portalId = selectedOption.portalManId ? selectedOption.value : 0;

    if (this.userId) {
      this.loading = true; // Show loading indicator
      this.subscriptions.push(
        this.moveBusinessServies
          .businessListByAdminUserOrPortal(this.userId, portalId)
          .pipe(finalize(() => (this.loading = false))) // Stop loading indicator
          .subscribe((list: any) => {
            this.businesslist = list || [];
            this.cdr.detectChanges(); // Update view after fetching business list
          })
      );
      this.loading = true; // Show loading indicator
      this.subscriptions.push(
        this.moveBusinessServies
          .getUserAndPortalTomoveBusiness(
            selectedOption.value,
            selectedOption.portalManId > 0
          )
          .pipe(finalize(() => (this.loading = false))) // Stop loading indicator
          .subscribe((selectedList: any) => {
            const toUsers: any[] = [
              {
                label: this.translate.instant('SELECT_DROPDOWN.SELECT'),
                value: null
              }
            ];
            if (selectedList) {
              selectedList.forEach((listData: any) => {
                toUsers.push({
                  label: listData.Name,
                  value: listData.Id,
                  portalManId: listData.PortalManagerId
                });
              });
            }
            this.SelectedUser = toUsers;
            this.cdr.detectChanges(); // Update view after fetching 'To' users
          })
      );
    } else {
      this.isFromUserSelected = false;
      this.initializeDropdowns(); // Ensure 'To' dropdown is reset
    }
  }

  onToUserChange(e: any) {
    this.selectedUserList = [];
    this.tblUser = [];

    const selectedOption = e.value
      ? this.SelectedUser.find(u => u.value === e.value)
      : null;

    if (!selectedOption || selectedOption.value === null) {
      this.selectedUserId = null;
      return;
    }

    this.selectedUserId = selectedOption.portalManId
      ? selectedOption.portalManId
      : selectedOption.value;

    if (selectedOption.portalManId && this.selectedUserId) {
      const managerId = this.selectedUserId;
      this.loading = true; // Show loading indicator
      this.subscriptions.push(
        this.businessPortalService
          .getPortalUsersByPortalManagerId(selectedOption.value)
          .pipe(finalize(() => (this.loading = false))) // Stop loading indicator
          .subscribe(result => {
            if (result) {
              this.tblUser = result.map(u => {
                const isManager = u.Id === managerId;
                return {
                  ...u,
                  IsChecked: isManager,
                  IsPortalManager: isManager
                };
              });
            } else {
              this.tblUser = [];
            }
            this.cdr.detectChanges(); // Update view after fetching table users
          })
      );
    }
  }

  userChecked(user: PortalUser) {
    // No specific action needed here for now, but might trigger change detection if issues arise
    // this.cdr.detectChanges();
  }

  moveBusiness() {
    if (!this.userId) {
      alert(this.translate.instant('PLEASE_SELECT_FROM_USER'));
      return;
    }
    if (!this.selectedUserId) {
      alert(this.translate.instant('PLEASE_SELECT_TO_USER'));
      return;
    }
    if (!this.selectedBusiness || this.selectedBusiness.length === 0) {
      alert(this.translate.instant('PLEASE_SELECT_ONE_RECORD'));
      return;
    }

    this.loading = true;

    let selectedPortalUser: any = [];
    if (this.tblUser && this.tblUser.length > 0) {
      this.tblUser.forEach((element: PortalUser) => {
        if (element.IsChecked) {
          selectedPortalUser.push({ Id: element.Id });
        }
      });
    }

    let selectBusinesslst: any = [];
    this.selectedBusiness.forEach((element: any) => {
      selectBusinesslst.push({
        Id: element.Id,
        Organization: element.OrganizationNumber,
        CompanyName: element.CompanyName,
        Company: element.CompanyNumber,
        AboutBusiness: element.AboutBusiness,
        Address: element.Address,
        Zipcode: element.Zipcode,
        Telephone: element.Telephone,
        Email: element.Email,
        BusinessUsersId: element.BusinessUsersId,
        Status: element.Status,
        ModifiedBy: BaseServices.UserId,
        PortalUsers: selectedPortalUser
      });
    });

    this.subscriptions.push(
      this.moveBusinessServies
        .updateBusiness(this.selectedUserId, selectBusinesslst)
        .pipe(
          finalize(() => {
            this.loading = false;
            this.cdr.detectChanges(); // Trigger change detection after loading stops
          })
        )
        .subscribe(
          (updatedBusiness: any) => {
            // Check response status/body for success confirmation if possible
            // Assuming any non-error response is success for now
            this.toasterComponent.callToast();
            this.resetForm();
          },
          error => {
            console.error('Error moving business:', error);
            alert(this.translate.instant('ERROR_MOVING_BUSINESS'));
          }
        )
    );
  }

  checkAll(isChecked: boolean) {
    _.forEach(this.tblUser, (item: PortalUser) => {
      if (!item.IsPortalManager) {
        item.IsChecked = isChecked;
      }
    });
    this.cdr.detectChanges(); // Explicitly trigger change detection here
  }

  get isAllUsersChecked(): boolean {
    if (!this.tblUser || this.tblUser.length === 0) {
      return false;
    }
    const checkableUsers = this.tblUser.filter(u => !u.IsPortalManager);
    if (checkableUsers.length === 0) {
      return true;
    }
    return checkableUsers.every(u => u.IsChecked);
  }

  get canCheckAll(): boolean {
    return this.tblUser && this.tblUser.some(u => !u.IsPortalManager);
  }

  resetForm() {
    this.moveBusinessForm.reset();
    this.businesslist = [];
    this.selectedBusiness = [];
    this.tblUser = [];
    this.selectedUserList = [];
    this.isFromUserSelected = false;
    this.userId = null;
    this.selectedUserId = null;
    this.loadInitialUsers(); // Reload initial 'From' users
    this.initializeDropdowns(); // Reset 'To' dropdown placeholder
    this.cdr.detectChanges(); // Ensure view reflects reset state
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      if (sub && !sub.closed) {
        sub.unsubscribe();
      }
    });
    this.subscriptions = [];
  }
}
